import AOS from "aos";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../../node_modules/aos/dist/aos.css";

function applyServiceTilt(el, clientX, clientY) {
  if (!el) return;
  const rect = el.getBoundingClientRect();
  const x = clientX - rect.left;
  const y = clientY - rect.top;
  const px = x / rect.width - 0.5;
  const py = y / rect.height - 0.5;

  const max = 8;
  const ry = px * max;
  const rx = -py * max;

  const mx = Math.max(0, Math.min(100, (x / rect.width) * 100));
  const my = Math.max(0, Math.min(100, (y / rect.height) * 100));

  el.style.setProperty("--rx", `${rx.toFixed(2)}deg`);
  el.style.setProperty("--ry", `${ry.toFixed(2)}deg`);
  el.style.setProperty("--mx", `${mx.toFixed(2)}%`);
  el.style.setProperty("--my", `${my.toFixed(2)}%`);
}

const SectionThree = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleAccordionClick = (index) => {
    setSelectedIndex(selectedIndex === index ? null : index);
  };

  const onServiceMove = (e) => {
    // update tilt per item (Home Services)
    applyServiceTilt(e.currentTarget, e.clientX, e.clientY);
  };

  const onServiceLeave = (e) => {
    const el = e.currentTarget;
    el.style.setProperty("--rx", "0deg");
    el.style.setProperty("--ry", "0deg");
    el.style.setProperty("--mx", "50%");
    el.style.setProperty("--my", "50%");
  };

  const accordionData = [
    {
      title: "Web Design & Development",
      content:
        "Our company builds responsive and visually appealing websites with strong attention to performance, usability, and consistent design across all devices.",
      listItems: [
        "Custom Website Design",
        "Frontend Development (React, Next.js)",
        "Backend Development (Django, Node.js)",
        "Responsive & SEO-Friendly Layouts",
      ],
    },
    {
      title: "Mobile Application",
      content:
        "Our company designs and develops mobile applications that provide seamless user experiences, high performance, and strong business functionality.",
      listItems: [
        "Cross-Platform App Development",
        "UI/UX Design for Mobile",
        "API Integration",
        "Performance Optimization",
      ],
    },
    {
      title: "SEO & Digital Marketing",
      content:
        "Our company helps businesses increase their online presence and attract more customers through data-driven SEO strategies and targeted digital marketing campaigns.",
      listItems: [
        "Search Engine Optimization (SEO)",
        "Social Media Marketing",
        "Content Strategy & Branding",
        "Analytics & Conversion Tracking",
      ],
    },
    {
      title: "UI & UX Design",
      content:
        "Our company crafts intuitive and visually engaging user interfaces, focusing on improving usability, accessibility, and user satisfaction through research and design thinking.",
      listItems: [
        "Wireframing & Prototyping",
        "User Journey Mapping",
        "Interactive Design",
        "Usability Testing & Feedback",
      ],
    },
  ];

  return (
    <>
      {/* <!-- ====================================== Section Three ===================================== --> */}
      <section className="section-three overflow-hidden">
        <div className="container">
          <div className="row services-section">
            <div className="col-xxl-4 col-xl-4 col-lg-4">
              <p className="our-services" data-aos="fade-up">
                OUR SERVICES
              </p>
              <h2 className="our-solution" data-aos="fade-up">
                Solution We Provide.
              </h2>
              <p className="uran odio" data-aos="fade-up">
                We craft scalable, secure, and user-centric solutions across
                web, mobile, and cloud platforms. Our expert team combines
                innovation with technology to drive your business forward.
              </p>

              <div className="services-circle-main">
                <div
                  className="view-work-circle btn btn1"
                  id="circle1"
                  data-aos="zoom-in-right"
                >
                  <Link to="/portfolio" className="a1">
                    VIEW OUR WORK
                  </Link>
                </div>
                {/* <div className="contact-circle" data-aos="zoom-in-left">
                  <div className="view-work-circle btn btn2">
                    <Link to="/contact">CONTACT ME</Link>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="col-xxl-7 col-xl-7 col-lg-7">
              <div id="faq-sec">
                {accordionData.map((item, index) => (
                  <div
                    className="nested-accordion"
                    data-aos="fade-up"
                    key={index}
                    onPointerMove={onServiceMove}
                    onPointerLeave={onServiceLeave}
                  >
                    <h3
                      className={`boder-top ${
                        selectedIndex === index ? "selected" : ""
                      }`}
                      onClick={() => handleAccordionClick(index)}
                    >
                      {item.title}
                    </h3>
                    <div
                      className="comment"
                      style={{
                        display: selectedIndex === index ? "block" : "none",
                      }}
                    >
                      {item.content}
                      <ul className="accor-list">
                        {item.listItems.map((listItem, idx) => (
                          <li key={idx}>{listItem}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== Section Three End===================================== --> */}
      {/* <!-- ====================================== User Branding Marquee Section ===================================== --> */}
      <div className="header_full_sec overflow-hidden">
        <div className="logos">
          <div className="logos-slide">
            <div className="ticker__item">User Interface</div>
            <div className="ticker__item ticker__item_dark">
              User Experience
            </div>
            <div className="ticker__item">Branding</div>
            <div className="ticker__item ticker__item_dark">Marketing</div>
            <div className="ticker__item">User Interface</div>
            <div className="ticker__item ticker__item_dark">
              User Experience
            </div>
            <div className="ticker__item">Branding</div>
            <div className="ticker__item ticker__item_dark">Marketing</div>
            <div className="ticker__item">User Interface</div>
            <div className="ticker__item ticker__item_dark">
              User Experience
            </div>
          </div>
        </div>
      </div>
      {/* <!-- ====================================== User Branding Marquee Section End ===================================== --> */}
    </>
  );
};
export default SectionThree;
